import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";
import { COLORS } from "constants/colors";

export const useParcelListStyles = makeStyles((theme: Theme) =>
  createStyles({
    table: {
      display: "grid",
      " & .MuiTableRow-head": {
        "& .MuiTableCell-head:first-child": {
          borderBottomLeftRadius: "5px",
          borderTopLeftRadius: "5px",
        },
        "& .MuiTableCell-head:nth-last-child(2)": {
          borderBottomRightRadius: "5px",
          borderTopRightRadius: "5px",
        },
      },
      "& .MuiTableRow-root:nth-child(1)": {
        border: "none",
      },
      " & .MuiTableRow-root": {
        "&:nth-of-type(odd)": {
          backgroundColor: "#fff",
        },
        "& > td": {
          paddingBottom: "6px",
          paddingTop: "6px",
        },
        "& > td:first-child": {
          borderLeft: "solid 6px",
          borderLeftColor: "#e2f4fb",
        },
      },
      "& .MuiTableCell-head": {
        marginBottom: "1em",
        height: "50px",
        backgroundColor: "#e2f4fb",
        color: "#399ebf",
      },
    },
  })
);
export const useNewOrderStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      position: "relative",
      overflowX: "unset",
      border: "none !important",
    },
    quantityContent: {
      flex: 1,
      display: "flex",
      justifyItems: "center",
      justifyContent: "center",
    },
    btnCheckDetail: {
      backgroundColor: "#399ebf",
      borderRadius: "6px",
      color: "#fff",
      margin: "14px",
      height: "25px",
      [theme.breakpoints.down("xs")]: {
        marginLeft: -15,
        alignItems: "basiline",
        marginTop: 21,
      },
    },
    activeInfoOrder: {
      height: "auto",
      display: "flex",
      border: "solid 1px #e3f8fa",
      backgroundColor: "rgba(215, 217, 226, 0.06)",
      [theme.breakpoints.down("xs")]: { width: "97%" },
    },
    checkAndButton: {
      display: "flex",
      width: "100px",
      [theme.breakpoints.down("xs")]: {
        display: "inline-flex",
        marginLeft: -7,
        gap: 12,
        alignItems: "center",
        marginTop: "auto",
      },
    },
    activeDetailsOrder: {
      display: "flex",
      alignItems: "center",
      width: "80%",
      color: "#399ebf",
      fontSize: "16px",
      [theme.breakpoints.down("xs")]: { display: "inline-block" },
    },
    detailsOrder: {
      display: "flex",
      alignItems: "center",
      width: "80%",
      color: "#399ebf",
      fontSize: "16px",
      paddingLeft: "20px !important",
      marginLeft: -100,
      [theme.breakpoints.down("xs")]: { display: "inline-block" },
    },
    addParcelActions: {
      display: "flex",
      width: "200px",
      alignItems: "center",
      [theme.breakpoints.down("xs")]: {
        alignItems: "center",
        display: "grid",
        width: "190px",
        paddingTop: "10px",
        marginLeft: -19,
      },
    },
    btnAddParcel: {
      marginLeft: "14px",
      [theme.breakpoints.down("xs")]: {
        marginTop: "30px",
        marginLeft: -53,
      },
    },
    activebadge: {
      paddingTop: "10px",
      marginLeft: -19,
      [theme.breakpoints.down("xs")]: {
        marginTop: -135,
        marginLeft: 18,
      },
    },

    actions: {
      marginLeft: "1px",
      [theme.breakpoints.down("xs")]: {
        marginLeft: "130px",
        marginTop: -41,
      },
    },
    icons: {
      margin: "10px",
      [theme.breakpoints.down("xs")]: {
        marginLeft: -15,
      },
    },
    actionsOrder: { position: "relative", top: "-9px", marginRight: "10px" },
    check: { padding: "3", [theme.breakpoints.down("xs")]: { marginTop: "30px" } },
    checkbox: {
      [theme.breakpoints.down("xs")]: {
        alignItems: "basiline",
        marginTop: "8px",
      },
    },
    addparcel: { [theme.breakpoints.down("xs")]: { background: "red" } },
    newParcel: {
      width: "100%",
      height: "24px",
      borderRadius: "3px",
      boxShadow: "0 3px 6px 0 rgba(0, 0, 0, 0.25)",
      fontSize: "8px",
      fontWeight: 900,
      padding: 10,
      marginLeft: "15px",
    },
    tableCellActions: {
      display: "flex",
      alignItems: "self-end",
      justifyContent: "space-evenly",
      marginBottom: "10px",
      [theme.breakpoints.down("xs")]: {
        display: "grid",
        marginLeft: "62px",
      },
    },
    tableCellIcon: {
      padding: 20,
      [theme.breakpoints.down("xs")]: {
        marginLeft: -8,
      },
    },
    activeTableCellIcon: {
      [theme.breakpoints.down("xs")]: {
        marginTop: "12px",
        marginLeft: -71,
      },
    },
    tableCell: {
      color: "#399ebf",
      fontSize: "16px",
      paddingRight: "20px !important",
      paddingTop: "12px",
    },
    tableCellName: {
      color: "#399ebf",
      fontSize: "16px",
      paddingRight: "20px !important",
      paddingLeft: "1px",
      [theme.breakpoints.down("xs")]: {
        textAlign: "justify",
        marginTop: -58,
        marginLeft: 58,
        padding: 1,
      },
    },
    activeTableCellName: {
      color: "#399ebf",
      fontSize: "16px",
      paddingLeft: "20px !important",
      [theme.breakpoints.down("xs")]: {
        marginTop: -35,
        marginLeft: -39,
      },
    },
    tableCellPhone: {
      color: "#757a93",
      fontSize: "14px",
      paddingRight: "20px !important",
      [theme.breakpoints.down("xs")]: {
        textAlign: "justify",
        marginLeft: 10,
        paddingTop: 28,
      },
    },
    activeTableCellPhone: {
      color: "#757a93",
      fontSize: "14px",
      paddingLeft: "20px !important",
      [theme.breakpoints.down("xs")]: {
        marginTop: 13,
        marginLeft: -33,
        padding: 8,
      },
    },
    tableCellAddress: {
      color: "#757a93",
      fontSize: "14px",
      paddingRight: "20px !important",
      [theme.breakpoints.down("xs")]: {
        marginLeft: 12,
        paddingTop: 7,
      },
    },
    activeTableCellAddress: {
      color: "#757a93",
      fontSize: "14px",
      paddingLeft: "20px !important",
      [theme.breakpoints.down("xs")]: {
        marginLeft: -28,
        textAlign: "start",
        padding: 3,
      },
    },
    flex: {
      display: "flex",
      alignItems: "center",
      [theme.breakpoints.down("xs")]: {
        display: "inline-grid",
      },
    },

    icon: {
      color: "#707070",
      fontSize: "10px",
      marginLeft: "10px",
    },
    iconRef: {
      fontSize: "10px",
      color: "#000",
      marginLeft: "10px",
    },
    desc: {
      display: "flex",
      alignItems: "center",
      paddingLeft: "0px",
      marginRight: "100px",
    },
    iconBox: {
      fontSize: "10px",
      color: "#399ebf",
    },
    texteIndicatif: {
      display: "flex",
      justifyContent: "center",
    },

    iconAction: {
      color: "#399ebf",
    },
    divider: {
      marginBottom: "10px",
      height: "0px",
    },
    tableParcel: {
      " & .MuiTableRow-root": {
        border: "solid 0.5px #d4d8d8",
        [theme.breakpoints.down("xs")]: { height: "14vh" },
      },
      "& .MuiTableCell-root:first-child": {
        border: "solid 0px #fff",
        paddingLeft: "0",
      },
    },
    infoOrder: {
      height: "auto",
      justifyContent: "space-between",
      display: "flex",
      border: "solid 1px #e3f8fa",
      backgroundColor: "rgba(215, 217, 226, 0.06)",
      [theme.breakpoints.down("xs")]: {
        display: "flex",
        width: "90%",
        marginTop: "-12px",
      },
    },

    divTableCell: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      height: "63px",
      border: "solid 1px #e3f8fa",
      backgroundColor: "rgba(215, 217, 226, 0.06)",
    },
    activeTableCell: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      height: "63px",
      border: "solid 1px #e3f8fa",
      backgroundColor: "rgba(215, 217, 226, 0.06)",
      [theme.breakpoints.down("xs")]: {
        display: "grid",
        alignItems: "center",
        height: "auto",
      },
    },
    divTable: {
      display: "flex",
      justifyContent: "center",
      alignItems: "baseline",
      [theme.breakpoints.down("xs")]: {},
    },

    multipleActions: {
      position: "relative",
      top: "8px",
      right: "4px",
      [theme.breakpoints.down("xs")]: { position: "relative", top: "40px", left: -9 },
    },
    rightAction: {
      marginTop: "7px",
    },
    recapBadge: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      width: "80px",
      position: "relative",
      left: "-50px",
      top: "5px",
      background: "yellow",
    },
    recapBadgeItem: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      width: "24px",
      height: "24px",
      backgroundColor: "#f2994a",
      borderRadius: "50%",
      color: "#fff",
      padding: "9px",
    },
    recapBadgeText: {
      fontFamily: "Montserrat",
      fontSize: "12px",
      fontWeight: "bold",
      fontStretch: "normal",
      fontStyle: "normal",
      lineHeight: "normal",
      letterSpacing: "normal",
      color: "#f2994a",
      marginTop: -20,
      marginLeft: 33,
    },
    BoxBadge: {
      [theme.breakpoints.down("xs")]: {},
    },
  })
);

export const recapStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      overflow: "auto",
      height: "71vh",
      display: "flex",
      position: "relative",
      flexDirection: "column",
      justifyContent: "space-between",
      [theme.breakpoints.down("xs")]: { height: "70vh", marginLeft: "5px" },
    },
    rootContent: {
      overflow: "auto",
      height: "71vh",
      display: "flex",
      flexDirection: "column",
      background: "#fff",
      borderRadius: 14,
      paddingLeft: 7,
      [theme.breakpoints.down("xs")]: { overflowX: "clip", overflowY: "scroll" },
    },
    top: {
      width: "99%",
      height: "92px",
      marginBottom: 20,
      borderRadius: 5,
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      padding: "13px 125px 14px 28px",
      background: "#e2f4fb",
      [theme.breakpoints.down("xs")]: {
        display: "block",
        width: "88%",
        height: "auto",
        padding: "15px 36px 24px 2px",
      },
    },
    orderGlobal: {
      [theme.breakpoints.down("xs")]: {
        marginLeft: "12px",
        width: "380px",
      },
    },
    orderItem: {
      color: "#f2994a",
      [theme.breakpoints.down("xs")]: {
        marginLeft: 200,
        marginTop: -42,
      },
    },
    orderJobType: {
      color: "#399ebf",
    },
    hrOrder: {
      display: "none",
      [theme.breakpoints.down("xs")]: {
        backgroundColor: "#399ebf",
        display: "block",
        marginLeft: -14,
      },
    },
    hr: {
      display: "none",
      [theme.breakpoints.down("xs")]: {
        background: "#399ebf",
        display: "block",
        marginTop: 18,
        marginLeft: -11,
      },
    },
    client: {
      color: "#399ebf",
      borderLeft: "2px solid #399ebf",
      paddingLeft: "15px",
      "& p": {
        margin: "6px",
      },
      "& p:nth-child(2)": {
        color: "#757a93",
        fontWeight: "bold",
      },
      "& p:nth-child(3)": {
        color: "#757a93",
        fontSize: "14px",
      },
      [theme.breakpoints.down("xs")]: {
        marginLeft: -6,
        fontSize: "12px",
        borderLeft: "none",
        width: "396px",
      },
    },
    date: {
      color: "#399ebf",
      fontSize: "16px",
      "& span": {
        color: "#757a93",
      },
      [theme.breakpoints.down("xs")]: {
        fontSize: "12px",
      },
    },
    jobTime: {
      borderLeft: "2px solid #399ebf",
      paddingLeft: "15px",
      [theme.breakpoints.down("xs")]: {
        borderLeft: "none",
        marginTop: -6,
      },
    },
    previousRecapJob: {
      marginTop: "5px",
      "&.MuiButton-root ": {
        width: "160px",
        marginLeft: "auto",
        [theme.breakpoints.down("xs")]: {
          width: " 143px",
          marginLeft: "20px",
        },
      },
    },
    confirmRecapJob: {
      marginTop: "5px",
      " &.MuiButton-root ": {
        width: "160px",
        marginLeft: "20px",
        marginRight: "3px",
      },
      [theme.breakpoints.down("xs")]: {
        width: " 143px",
        marginLeft: "26px",
      },
    },
    title: {
      fontSize: 20,
      fontWeight: 900,
      fontStretch: "normal",
      fontStyle: "normal",
      lineHeight: "normal",
      letterSpacing: "normal",
      color: "#399ebf",
      textTransform: "capitalize",
      paddingBottom: 20,
    },
    secondTitle: {
      fontSize: 18,
      fontWeight: 500,
      fontstretch: "normal",
      fontStyle: "normal",
      lineHeight: "normal",
      letterSpacing: "normal",
      color: "#787878",
    },
    buttons: {
      display: "flex",
      justifyContent: "end",
      textAlign: "end",
      marginBottom: 40,
      marginRight: 20,
      marginTop: "20px",
      [theme.breakpoints.down("xs")]: {
        marginRight: "204px",
        marginTop: "15px",
        marginBottom: "60px",
      },
    },
    dialogConfirm: { [theme.breakpoints.down("xs")]: { background: "red" } },
  })
);

export const JobCreationStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: "flex",
      flexDirection: "column",
      backgroundColor: "#fff",
      padding: "24px",
      height: "47rem",
      [theme.breakpoints.down("xs")]: { background: "#fafcfe" },
    },
    top: {
      flex: 1,
      display: "flex",
      flexDirection: "column",
      justifyContent: "space-between",
      [theme.breakpoints.down("xs")]: {
        width: "98vw",
        marginRight: -7,
        marginLeft: -8,
      },
    },
    title: {
      textAlign: "left",
      fontSize: 24,
      fontWeight: 900,
      fontStretch: "normal",
      fontStyle: "normal",
      lineHeight: "normal",
      letterSpacing: "normal",
      color: "#1a224b",
    },
    bottom: {
      flex: 5,
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      [theme.breakpoints.down("xs")]: {
        marginLeft: 10,
      },
    },
    form: {
      width: "100%",
      [theme.breakpoints.down("xs")]: {
        padding: "7px",
        position: "relative",
        top: "12px",
        borderRaduis: "4px",
        background: COLORS.white,
      },
    },
    userName: {
      textAlign: "left",
      fontSize: "24px",
      fontWeight: "bold",
      fontStretch: "normal",
      fontStyle: "normal",
      lineHeight: "normal",
      letterSpacing: "normal",
      color: "#757a93",
      [theme.breakpoints.down("xs")]: { fontSize: "13px", marginLeft: -5, marginTop: "8px" },
    },
    createJob: {
      [theme.breakpoints.down("xs")]: {
        marginBottom: "24px",
        marginTop: -9,
        marginLeft: "2px",
      },
    },
    step: {
      backgroundColor: "transparent",
      [theme.breakpoints.down("xs")]: {
        width: "65vh",
        marginLeft: -48,
        padding: "12px",
      },
    },
    currentUser: {
      [theme.breakpoints.down("xs")]: { fontSize: "12px" },
    },
    quitButton: {
      [theme.breakpoints.down("xs")]: {
        marginTop: "17px",
      },
    },
  })
);
export const useNewJobInfosStyles = makeStyles((theme: Theme) =>
  createStyles({
    title: {
      paddingBottom: 10,
      textTransform: "capitalize",
    },
    step: {
      fontSize: 20,
      fontWeight: 900,
      fontStretch: "normal",
      fontStyle: "normal",
      lineHeight: "normal",
      letterSpacing: "normal",
      color: "#399ebf",
      textTransform: "capitalize",
      paddingBottom: 10,
      [theme.breakpoints.down("xs")]: {
        marginLeft: 10,
      },
    },
    boldText: {
      fontWeight: "bold",
    },
    deliveryDateInfo: {
      fontSize: 16,
      fontWeight: 500,
      fontStretch: "normal",
      fontStyle: "normal",
      lineHeight: "normal",
      [theme.breakpoints.down("xs")]: {
        position: "relative",
        top: 5,
        width: "366px",
        marginLeft: 1,
      },
    },
    subTitle: {
      fontSize: 18,
      fontWeight: 500,
      fontStretch: "normal",
      fontStyle: "normal",
      lineHeight: "normal",
      letterSpacing: "normal",
      color: "#787878",
      [theme.breakpoints.down("xs")]: {
        top: -36,
        position: "relative",
        left: "12px",
      },
    },
    container: {
      display: "flex",
      flexDirection: "column",
      justifyContent: "space-between",
      height: "76vh",
    },
    root: {
      height: "70vh",
      justifyContent: "flex-end",
      [theme.breakpoints.down("xs")]: {
        overflowY: "scroll",
        overflowX: "none",
        width: "100%",
      },
    },
    vehicleContainer: {
      position: "relative",
      [theme.breakpoints.down("xs")]: {
        display: "contents",
      },
    },
    formVehicle: {
      [theme.breakpoints.down("xs")]: {
        marginLeft: "28px",
        marginRight: "46px",
      },
    },
    vehicleLabel: {
      position: "absolute",
      top: -11,
      color: "#707070",
      [theme.breakpoints.down("xs")]: {
        position: "relative",
        top: -7,
        marginLeft: "119px",
        left: -324,
        display: "none",
        color: "green",
      },
    },
    radioForm: {
      [theme.breakpoints.down("xs")]: {
        flexWrap: "nowrap",
      },
    },
    radioGroup: {
      [theme.breakpoints.down("xs")]: {
        position: "relative",
        top: -41,
      },
    },
    adresse: {
      [theme.breakpoints.down("xs")]: {
        marginTop: -46,
        marginRight: "29px",
        marginLeft: "53px",
      },
    },
    globalButton: {
      position: "relative",
      right: "15px",
      marginTop: "40px",
      display: "flex",
      bottom: "15px",
      [theme.breakpoints.down("xs")]: {
        marginTop: "17px",
        padding: "15px",
      },
    },
    button: {
      width: "160px",
      marginLeft: "20px",
      display: "flex",
      [theme.breakpoints.down("xs")]: {
        height: "56px",
        width: "215px",
        left: -30,
      },
    },
    date: {
      [theme.breakpoints.down("xs")]: {
        marginTop: "19px",
      },
    },
    fieldDate: {
      [theme.breakpoints.down("xs")]: {
        width: "86vw",
        left: 10,
      },
    },
    creneau: {
      [theme.breakpoints.down("xs")]: {
        marginTop: "24px",
      },
    },
    formCreneau: {
      [theme.breakpoints.down("xs")]: {
        width: "86vw",
        left: 20,
      },
    },
  })
);

export const useAirWayBillStyles = makeStyles((theme: Theme) =>
  createStyles({
    rootContent: {
      overflow: "auto",
      height: "63vh",
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      background: "#fff",
      borderRadius: 14,
      padding: 25,
      [theme.breakpoints.down("xs")]: { height: "77vh" },
    },
    buttons: {
      display: "flex",
      justifyContent: "end",
      textAlign: "end",
      marginTop: 20,
    },
    title: {
      fontSize: 20,
      fontWeight: 900,
      fontStretch: "normal",
      fontStyle: "normal",
      lineHeight: "normal",
      letterSpacing: "normal",
      color: "#399ebf",
      textTransform: "capitalize",
      marginBottom: 30,
    },
    imgAirwaysbills: {
      height: "10rem",
      [theme.breakpoints.down("xs")]: { width: "75vw", height: "17vh", right: "5px", position: "relative", top: -4 },
    },
    textInfos: {
      display: "flex",
      color: "#707070",
      marginTop: "auto",
      width: "25rem",
      [theme.breakpoints.down("xs")]: {
        textAlign: "justify",
        width: "19rem",
        marginTop: "inherit",
      },
    },
    loader: {
      marginTop: 20,
      marginLeft: "auto",
      marginRight: "auto",
    },
    checkbox: {
      color: "#757a93",
      position: "relative",
      top: "-58px",
      "&.MuiIconButton-root:hover": {
        backgroundColor: "inherit !important",
      },
      [theme.breakpoints.down("xs")]: {
        marginBottom: "82px",
      },
    },
    helperText: {
      color: "#b2b5bb",
      lineHeight: 2.5,
    },
    close: {
      display: "flex",
      alignItems: "baseline",
      justifyContent: "space-between",
    },
  })
);
